import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ActuatorInfo } from 'src/rdsap-api/model/actuatorInfo';
import { ActuatorsService } from 'src/rdsap-api';

// Define the custom data service
// this service overrides the @ngrx/data default data service and fetches data with custom services
@Injectable()
export class RdSAPInfoDataService extends DefaultDataService<ActuatorInfo> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    private actuatorService: ActuatorsService
  ) {
    super('RdSAPInfo', http, httpUrlGenerator);
  }

  getAll(): Observable<ActuatorInfo[]> {
    return this.actuatorService.newGetActuatorInfo().pipe(
      map(data => [data]) // Wrap data in an array as NgRx Data expects an array
    );
  }
}
